<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4" >
        <v-card class="elevation-12">
          <v-toolbar dark flat>
            <v-toolbar-title>Login</v-toolbar-title>
          </v-toolbar>
          <v-form action="#" @submit.prevent="login">
            <v-card-text>
              <span v-if="error"><strong class="red--text">{{errorText}}</strong></span>
              <v-text-field
                label="username"
                name="username"
                prepend-icon="person"
                type="text"
                id="username"
                v-model="username"
              />
              <v-text-field
                id="password"
                label="Password"
                name="password"
                prepend-icon="lock"
                type="password"
                v-model="password"
              />
              <v-text-field
                label="OTP"
                name="otp"
                prepend-icon="person"
                type="text"
                id="otp"
                v-model="otp"
              />
              <v-btn :disabled="makedisable" @click="sendOtp()" color="primary">Get OTP</v-btn> 
              
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn type="submit" color="primary">Login</v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "login",
  data() {
    return {
      username: '',
      password: '',
      otp: '',
      error: false,
      backendlogin:true,
      errorText: '',
      makedisable:false
    };
  },
  methods: {

    sendOtp(){
      this.makedisable = true;
      //
       this.$store.dispatch("getOtp",{}).then(() => {
          this.makedisable = false;
       }).catch(error => {
          this.error = true;
          this.errorText = error.response.data.message;
        });

    },
    login() {
      this.$store
        .dispatch("retrieveToken", {
          username: this.username,
          password: this.password,
          otp: this.otp,
          backendlogin:this.backendlogin
        })
        .then(() => {
          this.$store
            .dispatch("retrieveUserDetails")
            .then(() => {
              this.$router.push({ name: "balances" });
            })
        })
        .catch(error => {
          this.error = true;
          this.errorText = error.response.data.message;
        });
    }
  }
};
</script>

<style scoped>
.row {
  margin-left: 0px;
}
</style>